import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Checkbox, Form, Input } from 'antd';
import BannerInput from '@/components/BannerInput';
import { FiCamera } from 'react-icons/fi';

import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from '../ChatsList.module.scss';

const TitleChat = ({
  handleChangeName,
  updateImage,
  imagePreview,
  name,
  withBreakout,
  onSubmitForm,
  handleCancelButton,
  isTopic,
}) => {
  const { t } = useTranslation('chat');

  const [form] = Form.useForm();

  useEffect(() => {
    if (name) form.setFieldValue('chatName', name);
    if (withBreakout) form.setFieldValue('withBreakout', withBreakout);
  }, [name, withBreakout]);

  return (
    <div className={styles.groups__content}>
      <Form form={form} name='title-group' onFinish={onSubmitForm} className={styles.groups__form}>
        <div className={styles.groups__block}>
          {!isTopic && (
            <div className={styles.groups__inputPhoto}>
              {imagePreview ? (
                <img className={styles.groups__image} src={imagePreview} alt='' />
              ) : (
                <FiCamera size={26} />
              )}
              <BannerInput
                isChat
                ghost
                updateImage={updateImage}
                pushError={() => {}}
                typeUpload='image/png, image/jpeg, image/gif,'
                defaultAspect={16 / 9}
              />
            </div>
          )}
          <Form.Item
            className={cn(styles.groups__formItem, { [styles['groups__formItem_big']]: isTopic })}
            name='chatName'
            required
            rules={[{ required: true, message: t('error.0'), whitespace: true }]}
            label={t('nameGroup')}
            layout='vertical'
          >
            <Input
              onChange={e => handleChangeName && handleChangeName(e.target.value)}
              placeholder={t('nameGroup')}
              maxLength={128}
            />
          </Form.Item>
        </div>
        {isTopic && (
          <Form.Item
            className={cn(styles.groups__formItem, { [styles['groups__formItem_big']]: isTopic })}
            label={t('breakoutReport')}
            name='withBreakout'
            valuePropName='checked'
          >
            <Checkbox />
          </Form.Item>
        )}
        <div className={styles.groups__block_reverse}>
          <Form.Item>
            <Button type='primary' htmlType='submit'>
              {t('ok')}
            </Button>
          </Form.Item>
          <Button onClick={handleCancelButton}>{t('cancel')}</Button>
        </div>
      </Form>
    </div>
  );
};

TitleChat.propTypes = {
  updateImage: PropTypes.func,
  name: PropTypes.string,
  onSubmitForm: PropTypes.func,
  handleCancelButton: PropTypes.func,
  withBreakout: PropTypes.bool,
  handleChangeName: PropTypes.func,
};

export default TitleChat;
